export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";